export default __webpack_public_path__ + "static/media/logo_principal.7fe535d3.png";